import { CompanyType } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithGetAll } from "./mixins/WithGetAll";

export class Endpoint extends BaseEndpoint("company-types") {}

export const CompanyTypeEndpoint = WithGetAll<typeof Endpoint, CompanyType>(
  Endpoint,
);
